import OpenSeadragon from "openseadragon";
import  Overlay from "./Overlay.js";
import { merge } from "rxjs";
import { filter, debounceTime } from "rxjs/operators";

const _debug = false;

const _minTooltipWidth = 100;

const _config = {
    onHover: false,
    element: undefined,
    id: undefined,
    className: "image-overlay-tooltip",
    placement: "top"
}

export default class Tooltip {

    constructor(overlay, htmlText, viewer, config) {
        this.config = jQuery.extend(true, {}, _config, config);
        this.overlay = overlay;
        this.id = this.config.id ?? overlay.id + "_tooltip";
        if(this.config.element) {
            this.tooltipElement = this.config.element;
        } else {
            this.tooltipElement = _createElement(this.id, htmlText, this.config);
        }
        this.hide();
        if(_debug)console.log("created tooltip", this);

        if(this.config.onHover) {
            this.overlay?.element?.addEventListener("mouseenter", () => this.show());
            this.overlay?.element?.addEventListener("mouseleave", () => this.hide());
        } else {
            viewer.element?.addEventListener("click", e => {
                if(this.overlay.contains(_getLocation(e, viewer))) {
                    if(!this.isVisible()) {
                        this.show();
                    } else {
                        this.hide();
                    }
                }
            });
            this.tooltipElement.addEventListener("click", e => this.hide());
        }
        merge(
            viewer.onUpdate,
            viewer.onZoom,
            viewer.onPan,
        ).pipe(debounceTime(10), filter(e => this.isVisible())).subscribe(e => {
            _positionTooltip(this.overlay, this.tooltipElement, this.config.placement);
            if(_isOutsideBounds(this.overlay, viewer.element)) {
                this.hide();
            }
        });
    }

    isVisible() { 
        return this.tooltipElement.style.display != "none";
    }

    show() {
        this.tooltipElement.style.display = "block";
        _positionTooltip(this.overlay, this.tooltipElement, this.config.placement);
    }

    hide() {
        this.tooltipElement.style.display = "none";
    }

}

function _getLocation(event, viewer) {
    const point = new OpenSeadragon.Point(event.clientX, event.clientY);
    const coords = viewer.openseadragon.viewport.windowToViewportCoordinates(point);
    return coords;

}

function _isOutsideBounds(overlay, canvas) {
    const markerRect = overlay.element?.getBoundingClientRect();
    const canvasRect = canvas.getBoundingClientRect();
    if(markerRect && canvasRect) {
        return markerRect.right < canvasRect.left ||
          markerRect.left > canvasRect.right ||
          markerRect.bottom < canvasRect.top ||
          markerRect.top > canvasRect.bottom;
    } else {
        return true;
    }

  }

function _positionTooltip(overlay, tooltipElement, placement) {
    const rect = overlay?.element?.getBoundingClientRect();
    if(rect) {
        const tooltipRect = tooltipElement.getBoundingClientRect();
        if(_debug)console.log("position tooltip ", rect, placement, tooltipRect);
        // place tooltip above the marker
        switch(placement) {
            case "bottom": 
                tooltipElement.style.left = rect.left + window.scrollX + "px";
                tooltipElement.style.top = rect.bottom + window.scrollY + "px";
                tooltipElement.style.width = Math.max(_minTooltipWidth, rect.width ) + "px";
                break;
            default:
                tooltipElement.style.left = rect.left + window.scrollX + rect.width / 2 + "px";
                tooltipElement.style.top = rect.top + window.scrollY - tooltipRect.height + "px"; 
        }
    }
}

function _createElement(id, htmlText, config) {
    const element = document.createElement("div");
    element.id = id;
    element.className = config.className;
    element.innerHTML = htmlText;
    document.body.appendChild(element);
    return element;
}